module.exports = __webpack_public_path__ + "static/media/info-24px.3e5f9950.svg";